import React from 'react';
import { Stack, Typography } from '@mui/material';

import { ListCard } from 'components/Card';
import { Modal } from 'components/Modal';

export const SelectLotModal = ({ lots, isLoaded, open, handleClose, onSelect }) => (
  <Modal title="Select lot" open={open} handleClose={handleClose}>
    {isLoaded && lots.length === 0 && (
      <Typography color="text.secondary">No lots yet. Please add a lot first.</Typography>
    )}
    <Stack gap={1}>
      {lots.map((lot) => (
        <ListCard
          key={lot.lot_id}
          p={2}
          role="button"
          aria-label={`Select ${lot.name}`}
          sx={{ cursor: 'pointer' }}
          onClick={() => onSelect(lot)}
        >
          <Stack pl={1} minWidth={0}>
            <Typography variant="body1" fontWeight={700} fontSize="1rem" noWrap>
              {lot.name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {lot.role_count === 1 ? '1 role' : `${lot.role_count} roles`}
            </Typography>
          </Stack>
        </ListCard>
      ))}
    </Stack>
  </Modal>
);
